import { Button, Card, CardContent, Link, Typography } from '@mui/material';
import { Row, Spacer } from '../../components';

export interface SearchResultCardProps {
  icon: React.ReactNode;
  name: string;
  subtitle: string;
  onView: () => void;
  isFirst: boolean;
}

export const SearchResultCard: React.FC<SearchResultCardProps> = ({
  icon,
  name,
  subtitle,
  onView,
  isFirst,
}) => (
  <Card variant='ghost' color='secondary' sx={{ marginTop: isFirst ? '0px' : '10px' }}>
    <CardContent sx={{ padding: '13px 20px !important' }}>
      <Row style={{ justifyContent: 'space-between' }}>
        <Row style={{ alignItems: 'center' }}>{icon}</Row>
        <Spacer width='xxs' />
        <Row
          style={{
            alignItems: 'flex-start',
            flexDirection: 'column',
            flex: 1,
            overflow: 'hidden',
          }}>
          <Link
            className='darkenOnHover'
            noWrap={true}
            variant='p18SemiBold'
            color='secondary.main'
            sx={{ flex: 1 }}
            onClick={onView}>
            {name}
          </Link>
          <Spacer height='xxxs' />
          <Typography variant='p12' color='info.main' noWrap>
            {subtitle}
          </Typography>
        </Row>
        <Row style={{ alignItems: 'center' }}>
          <Button onClick={onView} className='cardAction' color='secondary'>
            View
          </Button>
        </Row>
      </Row>
    </CardContent>
  </Card>
);
